
import React, { Component } from 'react';
import { TakeoverEventType } from '@swivl/swivl-lib'
import './TakeoverEvent.scss';
import { ListItemData } from '../../ListItem';

export interface TakeoverEventProps {
  item:ListItemData;
}
export class TakeoverEvent extends React.Component<TakeoverEventProps> {

  render() {
    const payload = (this.props.item as any).message.payload;

    var avatarURL, text;
    if (payload.type === TakeoverEventType.TAKEOVER_STARTED) {
      avatarURL = (payload.avatarURL) ? payload.avatarURL : "https://swivl-cdn.s3-us-west-1.amazonaws.com/avatar-generic.png";
      text = (payload.name) ? payload.name.toUpperCase() + " HAS ENTERED THE CHAT" : "AN AGENT HAS ENTERED THE CHAT";
    } else {
      avatarURL = (payload.avatarURL) ? payload.avatarURL : "https://swivl-cdn.s3-us-west-1.amazonaws.com/avatar-generic.png";
      const botName = (payload.name)  ? payload.name.toUpperCase() : "THE BOT";
      text = "YOU'RE NOW CHATTING WITH " + botName;
    }

    return <div className="scc-TakeoverEvent">
              <div className="scc-TakeoverEvent-avatarWrapper"><img src={avatarURL} width="40" height="40" /></div>
              <div className="scc-TakeoverEvent-text swivl-timestamp">{text}</div>
    </div>
  }

}
